<template>
  <v-expansion-panel>
    <v-expansion-panel-header>
      <div class="turma-info">
        <v-avatar size="40" color="green darken-1">
          <span class="white--text text-h6">
            {{ iniciais }}
          </span>
        </v-avatar>

        <div class="flex-grow-1">
          <div class="text-subtitle-1 font-weight-medium text-uppercase">
            {{ turma.nome }}
          </div>
          <v-chip color="">{{ totalGestoes }} gestão(ões)</v-chip>
        </div>

        <div class="d-flex flex-column align-end">
          <v-chip :color="desempenhoGeralColor" text-color="white" class="mb-1">
            Desempenho: {{ desempenhoGeralPercentual }}%
          </v-chip>
          <!-- <v-chip :color="statusColor" text-color="white"> {{ totalGestoes }} Gestão(ões)</v-chip> -->
        </div>
      </div>
    </v-expansion-panel-header>

    <v-expansion-panel-content>
      <div class="gestoes-container">
        <v-divider class="my-4"></v-divider>

        <!-- Legenda Fixa que segue a rolagem -->
        <div class="legenda-fixa" :class="{ 'legenda-rolagem': isScrolled }">
          <div class="legenda-content">
            <span class="mr-2"><strong>Legenda de Status:</strong></span>
            <v-chip class="mr-1 mb-1" color="green" text-color="white"
              >Confirmações Concluídas</v-chip
            >
            <v-chip class="mr-1 mb-1" color="yellow" text-color="black"
              >Confirmações Incompletas</v-chip
            >
            <v-chip class="mr-1 mb-1" color="red" text-color="white">Nenhuma Confirmação</v-chip>
            <v-chip class="mr-1 mb-1" color="grey" text-color="white">Nenhum Lançamento</v-chip>
          </div>
        </div>

        <h4 class="text-h6 mb-3">Detalhes das Gestões</h4>

        <v-row>
          <v-col v-for="(gestao, index) in itemsParaTabela" :key="index" cols="12">
            <v-card
              class="gestao-card elevation-2 mb-4"
              outlined
              :class="{ 'zebra-even': index % 2 === 0, 'zebra-odd': index % 2 === 1 }"
            >
              <v-card-title class="pb-2">
                <v-row class="mb-2">
                  <v-col cols="12" sm="6" md="3">
                    <v-icon left color="primary">mdi-account</v-icon>
                    <span class="text-subtitle-1 word-break-keep">
                      <strong>Professor: </strong>
                      {{ gestao.professor }}
                    </span>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <v-icon left color="primary">mdi-book-open-variant</v-icon>
                    <span class="text-subtitle-1 word-break-keep">
                      <strong>Componente(s) Curricular(es):</strong>
                      {{ gestao.disciplinas }}
                    </span>
                  </v-col>
                  <v-col cols="12" sm="12" md="3">
                    <v-icon left color="primary">mdi-school</v-icon>
                    <span class="text-subtitle-1 word-break-keep">
                      <strong>Etapas: </strong>
                      <v-chip
                        v-for="serie in gestao.series"
                        :key="serie.id"
                        small
                        color="primary"
                        class="mr-1 mb-1"
                      >
                        {{ serie }}
                      </v-chip>
                    </span>
                  </v-col>
                  <v-col cols="12" sm="12" md="3">
                    <v-icon left color="primary">mdi-account-eye-outline</v-icon>
                    <span class="text-subtitle-1 word-break-keep">
                      <strong>Situação da Gestão: </strong>
                      <v-chip
                        :color="
                          gestao.nenhumLancamentoGeral
                            ? 'grey'
                            : gestao.relacaoAulasEtapas && gestao.totalPendencias === 0
                            ? 'green'
                            : 'red'
                        "
                        text-color="white"
                        class="ml-5 mb-1 status-chip"
                        :title="
                          gestao.nenhumLancamentoGeral
                            ? 'Nenhum lançamento de aulas ou planos para esta gestão'
                            : textoPendenciasPorGestao(gestao)
                        "
                      >
                        <span v-if="gestao.nenhumLancamentoGeral"> Nenhum Lançamento </span>
                        <span v-else-if="gestao.relacaoAulasEtapas && gestao.totalPendencias === 0">
                          Concluída
                        </span>
                        <span v-else v-html="textoPendenciasPorGestao(gestao)"></span>
                      </v-chip>
                    </span>
                  </v-col>
                </v-row>
              </v-card-title>

              <v-card-text>
                <!-- Tabela para Aulas -->
                <div
                  v-if="gestao.categorias.aulas && gestao.categorias.aulas.length > 0"
                  class="categoria-tabela mb-4"
                >
                  <h5 class="text-h6 mb-2 categoria-titulo">
                    <v-icon left color="blue">mdi-school</v-icon>
                    Aulas
                  </h5>
                  <v-data-table
                    :headers="tabelaHeadersAulas"
                    :items="gestao.categorias.aulas"
                    class="elevation-1"
                    hide-default-footer
                    disable-pagination
                    :items-per-page="-1"
                  >
                    <template v-slot:item.status="{ item }">
                      <v-chip
                        :color="item.status.color"
                        small
                        :text-color="item.status.color === 'yellow' ? 'black' : 'white'"
                      >
                        {{ item.status.text }}
                      </v-chip>
                    </template>
                    <template v-slot:item.disciplina="{ item }">
                      {{ item.disciplina || "N/A" }}
                    </template>
                  </v-data-table>
                </div>

                <!-- Tabela para Frequências -->
                <div
                  v-if="gestao.categorias.frequencias && gestao.categorias.frequencias.length > 0"
                  class="categoria-tabela mb-4"
                >
                  <h5 class="text-h6 mb-2 categoria-titulo">
                    <v-icon left color="orange">mdi-clipboard-check</v-icon>
                    Frequências
                  </h5>
                  <v-data-table
                    :headers="tabelaHeadersFrequencias"
                    :items="gestao.categorias.frequencias"
                    class="elevation-1"
                    hide-default-footer
                    disable-pagination
                    :items-per-page="-1"
                  >
                    <template v-slot:item.status="{ item }">
                      <v-chip
                        :color="item.status.color"
                        small
                        :text-color="item.status.color === 'yellow' ? 'black' : 'white'"
                      >
                        {{ item.status.text }}
                      </v-chip>
                    </template>
                    <template v-slot:item.disciplina="{ item }">
                      {{ item.disciplina || "N/A" }}
                    </template>
                  </v-data-table>
                </div>

                <!-- Tabela para Avaliações -->
                <div
                  v-if="gestao.categorias.avaliacoes && gestao.categorias.avaliacoes.length > 0"
                  class="categoria-tabela mb-4"
                >
                  <h5 class="text-h6 mb-2 categoria-titulo">
                    <v-icon left color="purple">mdi-file-document-edit</v-icon>
                    Notas
                  </h5>
                  <v-data-table
                    :headers="tabelaHeadersAvaliacoes"
                    :items="gestao.categorias.avaliacoes"
                    class="elevation-1"
                    hide-default-footer
                    disable-pagination
                    :items-per-page="-1"
                  >
                    <template v-slot:item.status="{ item }">
                      <v-chip
                        :color="item.status.color"
                        small
                        :text-color="item.status.color === 'yellow' ? 'black' : 'white'"
                      >
                        {{ item.status.text }}
                      </v-chip>
                    </template>
                    <template v-slot:item.disciplina="{ item }">
                      {{ item.disciplina || "N/A" }}
                    </template>
                  </v-data-table>
                </div>

                <!-- Tabela para Planos -->
                <div
                  v-if="gestao.categorias.planos && gestao.categorias.planos.length > 0"
                  class="categoria-tabela mb-4"
                >
                  <h5 class="text-h6 mb-2 categoria-titulo">
                    <v-icon left color="green">mdi-notebook-edit</v-icon>
                    Planos Bimestrais
                  </h5>
                  <v-data-table
                    :headers="tabelaHeadersPlanos"
                    :items="gestao.categorias.planos"
                    class="elevation-1"
                    hide-default-footer
                    disable-pagination
                    :items-per-page="-1"
                  >
                    <template v-slot:item.status="{ item }">
                      <v-chip
                        :color="item.status.color"
                        small
                        :text-color="item.status.color === 'yellow' ? 'black' : 'white'"
                      >
                        {{ item.status.text }}
                      </v-chip>
                    </template>
                    <template v-slot:item.disciplina="{ item }">
                      {{ item.disciplina || "N/A" }}
                    </template>
                  </v-data-table>
                </div>

                <!-- Mensagem quando não há dados -->
                <div v-if="!temDados(gestao.categorias)" class="text-center py-4">
                  <v-icon large color="grey">mdi-information</v-icon>
                  <div class="text-subtitle-1 grey--text">
                    Nenhum dado disponível para esta gestão
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </div>
      <scroll-top
        @click.native.prevent="scrollToTurma"
        :threshold="300"
        :bottom="86"
        :right="24"
        color="primary"
        icon="mdi-arrow-up-bold"
        small
      />
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
export default {
  name: "TurmaExpansionItem",

  props: {
    turma: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      painelAberto: [0],
      isScrolled: false,
      dialogTurmas: false,
      turmasSelecionadas: [],
      turmasTemporarias: [],
      tabelaHeadersAulas: [
        { text: "Etapa", value: "etapa", sortable: true, width: "10%" },
        { text: "Lançada(s)", value: "lancado", align: "center", width: "10%" },
        { text: "Esperado", value: "esperado", align: "center", width: "10%" },
        {
          text: "Aguardando Lançamento",
          value: "aguardando_lancamento",
          align: "center",
          width: "15%",
        },
        { text: "Confirmada(s)", value: "confirmadas", align: "center", width: "10%" },
        {
          text: "Aguardando Confirmação",
          value: "aguardando_confirmacao",
          align: "center",
          width: "15%",
        },
        { text: "Status", value: "status", sortable: false, align: "center", width: "15%" },
      ],
      tabelaHeadersPlanos: [
        { text: "Etapa", value: "etapa", sortable: true, width: "10%" },
        // { text: "Lançado", value: "geral", align: "center", width: "10%" },
        { text: "Lançado", value: "lancado", align: "center", width: "10%" },
        { text: "Esperado", value: "esperado", align: "center", width: "10%" },
        { text: "Pendente", value: "pendente", align: "center", width: "10%" },
        { text: "Plano Inválido", value: "plano_invalido", align: "center", width: "10%" },
        { text: "Confirmado", value: "confirmado", align: "center", width: "10%" },
        {
          text: "Aguardando Confirmação",
          value: "plano_aguardando_confirmacao",
          align: "center",
          width: "10%",
        },
        { text: "Status", value: "status", sortable: false, align: "center", width: "15%" },
      ],
    };
  },

  computed: {
    textoPendenciasPorGestao() {
      return (gestao) => {
        const pendenciaTypes = [];

        // Verificar pendências de confirmação de Aulas
        if (gestao.pendencias?.aulas) {
          const temPendenciaAulas = Object.values(gestao.pendencias.aulas).some(
            (dados) => (dados.aguardando_confirmacao || 0) > 0
          );
          if (temPendenciaAulas) {
            pendenciaTypes.push("Aulas");
          }
        }

        // Verificar pendências de confirmação de Planos
        if (gestao.pendencias?.planos_bimestrais) {
          const temPendenciaPlanos = Object.values(gestao.pendencias.planos_bimestrais)
            .flatMap(Object.values)
            .some((dados) => dados.tem_plano && !dados.plano_confirmado);
          if (temPendenciaPlanos) {
            pendenciaTypes.push("Planos");
          }
        }

        if (pendenciaTypes.length === 0) {
          return "Sem pendências";
        }
        return `Pendente em: ${pendenciaTypes.join(", ")}`;
      };
    },
    itemsParaTabela() {
      if (!this.turma.gestoes) return [];

      return this.turma.gestoes.map((gestao) => {
        // Recalcular pendências da perspectiva do Coordenador
        let totalPendenciasCoordenador = 0;

        // Pendências de Aulas (confirmação)
        if (gestao.pendencias?.aulas) {
          totalPendenciasCoordenador += Object.values(gestao.pendencias.aulas).reduce(
            (acc, dados) => acc + (dados.aguardando_confirmacao || 0),
            0
          );
        }

        // Pendências de Planos (confirmação)
        if (gestao.pendencias?.planos_bimestrais) {
          totalPendenciasCoordenador += Object.values(gestao.pendencias.planos_bimestrais)
            .flatMap(Object.values)
            .filter((dados) => dados.tem_plano && !dados.plano_confirmado).length;
        }

        const gestaoItems = {
          professor: gestao.professor_nome,
          disciplinas: gestao.disciplinas_da_gestao,
          series: gestao.series_da_turma,
          relacaoAulasEtapas: gestao.relacaoAulasEtapas,
          pendencias: gestao.pendencias,
          totalPendencias: totalPendenciasCoordenador, // Usar o total recalculado
          categorias: {
            aulas: [],
            planos: [],
          },
        };

        // Processar Aulas
        if (gestao.pendencias?.aulas) {
          gestaoItems.categorias.aulas = Object.entries(gestao.pendencias.aulas).map(
            ([etapa, info]) => {
              return {
                categoria: "Aulas",
                etapa,
                disciplina: "-",
                esperado: info.esperado,
                lancado: info.lancadas,
                pendente: info.pendentes,
                confirmadas: info.confirmadas,
                aguardando_confirmacao: info.aguardando_confirmacao,
                aguardando_lancamento: info.aguardando_lancamento,
                status: this.getStatus(
                  info.lancadas,
                  info.confirmadas,
                  info.aguardando_confirmacao
                ),
              };
            }
          );
        }

        // Processar Planos
        if (gestao.pendencias?.planos_bimestrais) {
          gestaoItems.categorias.planos = Object.entries(
            gestao.pendencias.planos_bimestrais
          ).flatMap(([etapa, disciplinas]) =>
            Object.entries(disciplinas).map(([disciplina, info]) => {
              return {
                categoria: "Planos",
                etapa,
                disciplina,
                esperado: 1,
                lancado: info.tem_plano ? 1 : 0,
                confirmado: info.plano_confirmado ? 1 : 0,
                pendente: info.tem_pendencia ? 1 : 0,
                plano_aguardando_confirmacao: info.plano_aguardando_confirmacao ? 1 : 0,
                plano_invalido: info.plano_invalido ? 1 : 0,
                status: this.getStatus(
                  info.tem_plano ? 1 : 0,
                  info.plano_confirmado ? 1 : 0,
                  info.plano_aguardando_confirmacao ? 1 : 0
                ),
              };
            })
          );
        }

        const temItens =
          gestaoItems.categorias.aulas.length > 0 || gestaoItems.categorias.planos.length > 0;

        const todosSemLancamento =
          temItens &&
          gestaoItems.categorias.aulas.every((item) => item.status.text === "Nenhum Lançamento") &&
          gestaoItems.categorias.planos.every((item) => item.status.text === "Nenhum Lançamento");

        gestaoItems.nenhumLancamentoGeral = todosSemLancamento;

        return gestaoItems;
      });
    },

    iniciais() {
      if (!this.turma.nome) return "N/A";
      const nomes = this.turma.nome.split(" ");
      if (nomes.length === 1) {
        return nomes[0].substring(0, 2).toUpperCase();
      }
      return (nomes[0][0] + nomes[nomes.length - 1][0]).toUpperCase();
    },

    totalGestoes() {
      return this.turma.gestoes?.length || 0;
    },

    totalPendenciasAulas() {
      if (!this.turma.gestoes) return 0;
      return this.turma.gestoes.reduce((total, gestao) => {
        return total + (gestao.pendencias?.totais?.aulas || 0);
      }, 0);
    },

    totalPendenciasPlanos() {
      if (!this.turma.gestoes) return 0;
      return this.turma.gestoes.reduce((total, gestao) => {
        return total + (gestao.pendencias?.totais?.planos_bimestrais || 0);
      }, 0);
    },

    /**
     * Calcula o desempenho geral do turma com base no total de itens concluídos em relação ao total de itens esperados em todas as suas gestões.
     * O cálculo considera quatro categorias principais:
     *
     * 1.  **Aulas:** Compara o número de aulas 'lançadas' com o número de aulas 'esperadas'.
     * 2.  **Frequências:** Compara o número de frequências 'lançadas' com o número 'esperado' de registros de frequência.
     * 3.  **Avaliações:** Compara o número de avaliações 'lançadas' com o número 'esperado'.
     * 4.  **Planos Bimestrais:** Verifica se um plano foi entregue (concluído) para cada um esperado.
     *
     * O resultado final é uma porcentagem que representa a proporção de itens concluídos em relação ao total esperado.
     */
    desempenhoGeralPercentual() {
      if (!this.turma.gestoes) return 100;

      const { totalEsperado, totalConcluido } = this.turma.gestoes.reduce(
        (acc, gestao) => {
          if (!gestao.pendencias) return acc;

          // Lógica para Aulas (perspectiva do Coordenador)
          if (gestao.pendencias.aulas) {
            Object.values(gestao.pendencias.aulas).forEach((dados) => {
              // O que se espera confirmar é o total de aulas lançadas pelo professor.
              const esperadoConfirmacao = dados.lancadas || 0;
              // O que foi concluído (confirmado) pelo coordenador.
              const concluidoConfirmacao = dados.confirmadas || 0;

              acc.totalEsperado += esperadoConfirmacao;
              acc.totalConcluido += concluidoConfirmacao;
            });
          }

          // Lógica para Planos (perspectiva do Coordenador)
          if (gestao.pendencias.planos_bimestrais) {
            Object.values(gestao.pendencias.planos_bimestrais).forEach((disciplinas) => {
              Object.values(disciplinas || {}).forEach((dados) => {
                // Apenas planos que foram lançados pelo professor entram no cálculo.
                if (dados.tem_plano) {
                  acc.totalEsperado += 1;
                  // Concluído = Confirmado OU Invalidado (ambas são ações do coordenador)
                  if (dados.plano_confirmado || dados.plano_invalido) {
                    acc.totalConcluido += 1;
                  }
                }
              });
            });
          }

          return acc;
        },
        { totalEsperado: 0, totalConcluido: 0 }
      );

      if (totalEsperado === 0) return 0; // Se não há nada a fazer, o desempenho é 0%
      return Math.round((totalConcluido / totalEsperado) * 100);
    },

    desempenhoGeralColor() {
      return this.desempenhoGeralPercentual > 70 ? "green" : "red";
    },

    statusColor() {
      let tiposPendencias = 0;
      if (this.totalPendenciasAulas > 0) tiposPendencias++;
      if (this.totalPendenciasPlanos > 0) tiposPendencias++;
      switch (tiposPendencias) {
        case 0:
          return "green";
        case 1:
          return "warning";
        case 2:
          return "orange";
        case 3:
          return "error";
        default:
          return "error";
      }
    },
  },

  methods: {
    scrollToTurma() {
      this.$el.scrollIntoView({ behavior: "smooth" });
    },

    abrirDialogTurmas() {
      this.turmasTemporarias = [...this.turmasSelecionadas];
      this.dialogTurmas = true;
    },

    cancelarDialog() {
      this.dialogTurmas = false;
    },

    salvarTurmas() {
      this.turmasSelecionadas = [...this.turmasTemporarias];
      this.dialogTurmas = false;
    },

    getStatus(lancadas, confirmadas, aguardando_confirmacao) {
      if (lancadas === 0) return { color: "grey", text: "Nenhum Lançamento" };
      if (aguardando_confirmacao === 0) return { color: "green", text: "Completo" };
      if (confirmadas > 0 && aguardando_confirmacao > 0)
        return { color: "yellow", text: "Incompleto" };
      if (confirmadas === 0 && aguardando_confirmacao > 0)
        return { color: "red", text: "Nenhuma Confirmação" };
      return { color: "grey", text: "Indefinido" };
    },

    temDados(categorias) {
      return Object.values(categorias).some((array) => array.length > 0);
    },

    handleScroll() {
      const expansionContent = this.$el.querySelector(".v-expansion-panel-content");
      if (expansionContent) {
        this.isScrolled = expansionContent.scrollTop > 50;
      }
    },
  },

  mounted() {
    // Adicionar listener de scroll ao conteúdo expandido
    const expansionContent = this.$el.querySelector(".v-expansion-panel-content");
    if (expansionContent) {
      expansionContent.addEventListener("scroll", this.handleScroll);
    }
  },

  beforeDestroy() {
    // Remover listener para evitar memory leaks
    const expansionContent = this.$el.querySelector(".v-expansion-panel-content");
    if (expansionContent) {
      expansionContent.removeEventListener("scroll", this.handleScroll);
    }
  },
};
</script>

<style scoped>
.turma-info {
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
}

.professor-avatar {
  flex-shrink: 0;
}

.gestao-card {
  border-left: 4px solid #4caf50;
  /* green  */
  transition: all 0.3s ease;
}

.zebra-even {
  background-color: #ffffff !important;
}

.zebra-odd {
  background-color: #f5f5f5 !important;
}

.gestoes-container {
  padding: 0 8px;
  position: relative;
}

.word-break-keep {
  word-break: keep-all;
}

.categoria-tabela {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 16px;
  background-color: #fafafa;
}

.categoria-titulo {
  color: #424242;
  border-bottom: 2px solid;
  padding-bottom: 8px;
}

.categoria-titulo .v-icon {
  margin-right: 8px;
}

/* Estilos para a legenda fixa */
.legenda-fixa {
  position: sticky;
  top: 0;
  z-index: 10;
  background-color: white;
  padding: 8px 0;
  margin-bottom: 16px;
  border-bottom: 1px solid #e0e0e0;
  transition: all 0.3s ease;
}

.legenda-rolagem {
  background-color: #f5f5f5;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 12px 0;
}

.legenda-content {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

/* Ajuste para garantir que o conteúdo não fique atrás da legenda fixa */
.gestoes-container > .text-h6 {
  margin-top: 16px;
}

/* Responsividade */
@media (max-width: 600px) {
  .turma-info {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .turma-info .v-chip {
    align-self: flex-end;
  }

  .categoria-tabela {
    padding: 8px;
  }

  .legenda-content {
    flex-direction: column;
    align-items: flex-start;
  }

  .legenda-content .text-caption {
    margin-bottom: 8px;
  }
}

.status-chip {
  height: auto !important;
  min-height: 42px;
  padding-top: 6px !important;
  padding-bottom: 6px !important;
  line-height: 1.3;
  text-align: center;
  white-space: normal;
}
</style>
